import { NotificationEventType } from "@modules/graphql/types"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"

export const notificationEventTypeLabels: Record<
  NotificationEventType,
  string
> = {
  [NotificationEventType.BuildFailed]:
    notificationDeploysText.labels.eventTypeBuildFailed,
  [NotificationEventType.BuildSucceeded]:
    notificationDeploysText.labels.eventTypeBuildSucceeded,
  [NotificationEventType.DeployFailed]:
    notificationDeploysText.labels.eventTypeDeployFailed,
  [NotificationEventType.DeploySucceeded]:
    notificationDeploysText.labels.eventTypeDeploySucceeded,
}
